import React, { Component, PropTypes } from 'react';
import { Colors } from 'Css';

const css = oxygenCss({
  root: {
    borderStyle: 'none none solid none',
    borderWidth: 1,
    borderColor: Colors.text.Dark.divider,
    height: 0
  }
});

class ListItem extends Component {
  render() {
    return <div className={css.root} />;
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/js/components/List/Divider.js